import io from 'socket.io-client'
import config from '../config'

function SocketIOProvider (endpoint = '', wsBaseUrl = config.wsBaseUrl) {
  if (window.prerenderCloudIsServerSideRendering) {
    return {
      on: () => { },
      off: () => { },
      emit: () => { },
      removeAllListeners: () => { }
    }
  }
  const socket = io.connect(`${wsBaseUrl + endpoint}`, {
    path: '/ws',
    reconnectionAttempts: 10
  })
  return socket
}

export default SocketIOProvider
